import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import Postnatal from "./sections/Postnatal";
import Philosophy from "./sections/Philosophy";
import Expertise from "./sections/Expertise";
import Process from "./sections/Process";
import Testimonials from "./sections/Testimonials";
import Credentials from "./sections/Credentials";
import Contact from "./sections/Contact";
import Blog from "./sections/Blog";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Navigation />
      
      
      
      <Postnatal />
      <Philosophy />
      <Expertise />
      <Process />
      <Testimonials />
      <Credentials />
      <Contact />
      <Blog />
      <Footer />
    </div>;
}